export const handleClick = setAnchorEl => e => setAnchorEl(e.currentTarget);